import React, { useState, useEffect, useContext } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import DeployPageBreadcrumb from './DeployPageBreadcrumb';
import apiService from '../../services/apiService';
import { DeployCard } from './DeployCard2';
import { SyncCard } from './SyncCard';
import ExportBackendSpinner from '../BuildApps/Spinners/ExportBackendSpinner';
import ExportProjectSpinner from '../BuildApps/Spinners/ExportProjectSpinner';
import ExportFrontSdk from '../BuildApps/Spinners/ExportFrontSdk';
import SyncToGithub from '../BuildApps/Spinners/SyncToGithub';
import ExportProjectCode, { createJavascriptPerPage, requestCodeServer } from './ExportProjectCode';
import AuthContext from '../AppAuthContext';
import ExportProjectCodeViolationsPopUp from '../GeneralComponents/ExportProjectCodeViolationsPopUp';

// This component is responsible to render content in about_page

const DeployPage = () => {
  const location = useLocation();
  const [selectedProject, setSelectedProject] = useState(location.state.selectedProject);
  const [projectName, setProjectName] = useState('');
  const [projectId, setProjectId] = useState('');
  const [deployConfig, setDeployConfig] = useState();
  const [arrayOfConfigs, setArrayOfConfigs] = useState([]);
  const [displayExportProjectSpinner, setDisplayExportProjectSpinner] = useState(false);
  const [displayExportBackendSpinner, setDisplayExportBackendSpinner] = useState(false);
  const [displayExportFrontSdkSpinner, setDisplayExportFrontSdkSpinner] = useState(false);
  const [displaySyncToGithubSpinner, setDisplaySyncToGithubSpinner] = useState(false);
  const [displayWentWrongUi, setDisplayWentWrongUi] = useState(false);
  const { dispatch } = useContext(AuthContext); // Method to update React state
  const [currentStep, setCurrentStep] = useState(1);
  const [violationMessage, setViolationMessage] = useState('');
  const [openExportProjectCodePopUp, setOpenExportProjectCodePopUp] = useState(false);

  // Function to handle the Download and the Synchronization to github
  const handleNextStep = async (selectedConfig) => {
    // Set the selected configuration
    setDeployConfig(selectedConfig);

    // If the selected configuration is localhost, then the user can download the project
    if (selectedConfig.serverName === 'local') {
      setDisplayExportProjectSpinner(true);
      const reason = 'ExportFrontSdk';
      const spinner = setDisplayExportProjectSpinner;
      await createJavascriptPerPage(
        spinner,
        dispatch,
        setDisplayWentWrongUi,
        reason,
        setViolationMessage,
        setOpenExportProjectCodePopUp
      );
      await requestCodeServer(
        spinner,
        dispatch,
        setDisplayWentWrongUi,
        setViolationMessage,
        setOpenExportProjectCodePopUp
      );
    }
    // If the selected configuration is not localhost, then the user can synchronize the project to github
    else {
      const reason = 'SyncToGithub';
      const spinner = setDisplaySyncToGithubSpinner;
      setDisplaySyncToGithubSpinner(true);

      createJavascriptPerPage(
        spinner,
        dispatch,
        setDisplayWentWrongUi,
        reason,
        setViolationMessage,
        setOpenExportProjectCodePopUp
      )
        .then(() => {
          // Take user to the deployment page
          setCurrentStep(currentStep + 1);
        })
        .catch((error) => {
          throw error;
        });
    }
  };

  // Handle 'back' button click
  const handleBackStep = () => {
    setCurrentStep(currentStep - 1);
    if (currentStep <= 1) setCurrentStep(1);
  };

  useEffect(() => {
    //  escapes when there is no selection
    if (selectedProject === -1) return;
    const { name, _id } = JSON.parse(localStorage.getItem('data'))[selectedProject];
    setProjectId(_id);
    setProjectName(name);
    apiService
      .readProject(_id, { field: 'deployConfiguration' })
      .then(({ data }) => {
        setDeployConfig(
          data.deployConfiguration || {
            name: '',
            serverName: '',
            url: '',
            port: '',
          }
        );
      })
      .catch((error) => {
        throw error;
      });
  }, [selectedProject]);

  useEffect(() => {
    apiService
      .getUserField('deployConfiguration')
      .then(({ data }) => Promise.all(data.map((configId) => apiService.getDeployConfig(configId))))
      .then((responseArray) => {
        if (
          deployConfig?.name &&
          !responseArray.find((config) => config.name === deployConfig.name)
        )
          setArrayOfConfigs(responseArray.concat(deployConfig));
        else setArrayOfConfigs(responseArray);
      })
      .catch((error) => {
        throw error;
      });

    // apiService.getAllDeployConfigs().then((responseArray) => setArrayOfConfigs(responseArray));
  }, [selectedProject, deployConfig]);

  return (
    <div style={{ height: '100%', overflow: 'scroll' }}>
      <div style={{ width: '100%', zIndex: '1000' }}>
        <WabliAppBar /> {/* Wabli app bar */}
        <DeployPageBreadcrumb
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />{' '}
        {/* Deploy breadcrumb */}
        <ExportProjectSpinner
        displayExportProjectSpinner={displayExportProjectSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <ExportBackendSpinner
        displayExportBackendSpinner={displayExportBackendSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <ExportFrontSdk
        displayExportFrontSdkSpinner={displayExportFrontSdkSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <SyncToGithub
        displaySyncToGithubSpinner={displaySyncToGithubSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <ExportProjectCodeViolationsPopUp
        open={openExportProjectCodePopUp}
        setOpen={setOpenExportProjectCodePopUp}
        title={violationMessage}
      />
      </div>
      {/**/}

      {deployConfig && arrayOfConfigs && (
        <Body
          name={projectName}
          deployData={deployConfig}
          arrayOfConfigs={arrayOfConfigs}
          selectedProject={selectedProject}
          projectId={projectId}
          onNext={handleNextStep}
          currentStep={currentStep}
          onBack={handleBackStep}
          setDisplayExportBackendSpinner={setDisplayExportBackendSpinner}
          setDisplayExportFrontSdkSpinner={setDisplayExportFrontSdkSpinner}
          setDisplayWentWrongUi={setDisplayWentWrongUi}
          setDisplaySyncToGithubSpinner={setDisplaySyncToGithubSpinner}
        />
      )}
    </div>
  );
};
const Body = ({
  name,
  deployData,
  arrayOfConfigs,
  selectedProject,
  projectId,
  onNext,
  currentStep,
  onBack,
  setDisplayExportBackendSpinner,
  setDisplayExportFrontSdkSpinner,
  setDisplayWentWrongUi,
  setDisplaySyncToGithubSpinner
}) => (
  <div className={clsx('generalMarg', 'spacingTop')} style={{ height: '75%' }}>
    <h2 style={{ fontWeight: '500', fontSize: '1.5rem' }}>{name}</h2>
    <div style={{ display: 'flex', height: '75%', justifyContent: 'space-between' }}>
      {currentStep === 1 && (
        <SyncCard
          deploymentData={deployData}
          title="Synchronization Card"
          tooltipMessage="This card shows the synchronization summary"
          arrayOfConfigs={arrayOfConfigs}
          projectId={projectId}
          selectedProject={selectedProject}
          onNext={onNext}
        />
      )}
      {currentStep === 2 && (
        <DeployCard
          deploymentData={deployData}
          title="Deployment Card"
          tooltipMessage="This card shows the deployment summary"
          projectId={projectId}
          onBack={onBack}
        />
      )}
      <div style={{ width: '50%', height: '75%', display: 'flex', justifyContent: 'center', marginTop: '0.1rem', alignItems: 'center' }}>
        <ExportProjectCode
        setDisplayExportBackendSpinner={setDisplayExportBackendSpinner}
        setDisplayExportFrontSdkSpinner={setDisplayExportFrontSdkSpinner}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
        setDisplaySyncToGithubSpinner={setDisplaySyncToGithubSpinner}
      />
      </div>
      
      {/* {currentStep === 3 && <Step3 onNext={onNext}/>} */}
    </div>
  </div>
);
export default DeployPage;
